import axios from 'axios';
import config from '@/config';
import SessionUtil from '@/utils/SessionUtil';

export default {

  getFuturePrices(type, orderData, adCode) {
    return new Promise(function(resolve, reject) {
      axios.get(config.api + '/public/trip-cost-estimate', {
        params: {
          coordinateType: 'GCJ02',
          tripType: type,
          cityCode: adCode ? adCode : '',
          departureLongitude: orderData.orderBeginAddressLongitude,
          departureLatitude: orderData.orderBeginAddressLatitude,
          destinationLongitude: orderData.orderTargetAddressLongitude,
          destinationLatitude: orderData.orderTargetAddressLatitude,
          peopleCount: orderData.peopleCount
        }
      }).then(function(response) {
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        if (rs.success) {
          resolve({ response: response, success: true, data: rs.result });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  getFinishOrders(pageIndex, orderType) {
    return new Promise(function(resolve, reject) {
      axios.get(config.api + '/order/finished', {
        params: {
          coordinateType: 'GCJ02',
          pageIndex: pageIndex,
          orderType: orderType
        }
      }).then(function(response) {
        // console.log(response);
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        if (rs.success) {
          resolve({ response: response, success: true, orders: rs.result });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  getProgressOrder() {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.get(config.api + '/order/in-progress', {
        params: {
          coordinateType: 'GCJ02'
        }
      }).then(function(response) {
        const rs = response.data;
        if (rs.code === 200) {
          resolve({ response: response, success: true, orderData: rs.data });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  getWaitPayOrders() {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.get(config.api + '/order/wait-payment', {
        params: {
          coordinateType: 'GCJ02'
        }
      }).then(function(response) {
        const rs = response.data;
        if (rs.code === 200) {
          resolve({ response: response, success: true, orders: rs.data });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  getWaitDispatchOrder() {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.get(config.api + '/order/in-dispatch', {
        params: {
          coordinateType: 'GCJ02'
        }
      }).then(function(response) {
        const rs = response.data;
        if (rs.code === 200) {
          resolve({ response: response, success: true, orderData: rs.data });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  getOrderDetail(orderId) {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.get(config.api + '/order/order-detail', {
        params: {
          orderId: orderId
        }
      }).then(function(response) {
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        if (rs.success) {
          resolve({ response: response, success: true, orderDetail: rs.result });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  submitOrder(orderData) {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.post(config.api + '/car-hailing/publish', orderData, {
        // headers: {
        //     "content-type": "application/x-www-form-urlencoded",
        // },
        // params: orderData
      }).then(function(response) {
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        if (rs.success) {
          resolve({ response: response, success: true, order_number: rs.result.order_number });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  cancelOrder(orderNumber, cancelReason) {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.post(config.api + '/car-hailing/cancel', null, {
        params: {
          order_number: orderNumber,
          orderReturnReason: cancelReason
        }
      }).then(function(response) {
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        if (rs.success) {
          resolve({ response: response, success: true });
        } else {
          resolve({ response: response, success: false });
        }
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  paymentOrder(orderNumber, couponId) {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.get(config.api + '/pay/order-pay', {
        params: {
          orderNumber: orderNumber,
          paymentType: 'PAYMENT_TYPE_WECHAT_PAY',
          couponId: couponId
        }
      }).then(function(response) {
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        resolve({ response: response, success: rs.success });
      }).catch(function(error) {
        reject(error);
      });
    });
  },

  privacyCall(orderNumber) {
    return new Promise(function(resolve, reject) {
      if (!SessionUtil.isLogin()) {
        return;
      }
      axios.get(config.api + '/privacy-call/call', {
        params: {
          orderNumber: orderNumber
        }
      }).then(function(response) {
        const rs = response.data;
        if (!('success' in rs)) rs.success = rs.code === 200;
        if (!('result' in rs)) rs.result = rs.data;
        resolve({ response: response, success: rs.success });
      }).catch(function(error) {
        reject(error);
      });
    });
  }
};
